import Swal from 'sweetalert2/src/sweetalert2.js';

$(document).ready(function() {
    const companies = {
        isLoading: false,
        init() {
            $(document).on('click', '#add-new-company', this, this.addNewCompanyModal);
            $(document).on('click', '.edit-company', this, this.editCompanyModal);
            $(document).on('click', '#save-company', this, this.updateCompany);
            $(document).on('click', '#save-new-company', this, this.saveCompany);
            $(document).on('click', '.delete-company', this, this.deleteCompany);
            $(document).on('change', '#company-county', this, this.getCities);
        },
		getCities(event) {
			const _this = event.data;

			let id = $('#company-county option:selected').val();
			if (!id || id == null || id == '') {
				return;
			}

			let old = $('#company-city').data('old');

			$.ajax({
                type: "GET",
                url: `${baseURL}/state/${id}/cities`,
				success: function(cities, xhr) {
					$('#company-city').find('option:not(:first)').remove();

					for(var i in cities) {
						$('#company-city').append('<option value="'+cities[i].id+'" '+(cities[i].id == old ? 'selected="selected"' : '')+'>'+cities[i].name+'</option>');
					}
                },
                error(error) {
                    console.log(error);
                },
			});
		},
		editCompanyModal(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/company/${id}`,
				success: function(response, xhr) {
					if (response == 'invalid-id') {
						alert('Invalid ID!');
						return false;
					}

                    $('#company-modal').html(response);
                    $('#company-modal').modal();
                },
                error(error) {
                    console.log(error);
                },
			});
		},
		updateCompany(event) {
            const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

            if (_this.isLoading) {
                return false;
            }

            $('.form-new-company').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#company-name').val() == '') {
				$('#company-name').addClass('is-invalid');
				errors = true;
			}
			if ($('#company-cui-number').val() == '') {
				$('#company-cui-number').addClass('is-invalid');
				errors = true;
			}
			/*if ($('#company-county option:selected').val() == '') {
				$('#company-county').parent().addClass('has-error');
				errors = true;
			}
			if ($('#company-city option:selected').val() == '') {
				$('#company-city').parent().addClass('has-error');
				errors = true;
			}*/
			if ($('#company-city').val() == '') {
				$('#company-city').addClass('is-invalid');
				errors = true;
			}
			if ($('#company-address').val() == '') {
				$('#company-address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $('#_token_company').val();
            values += '&id=' + id;
			values += '&name=' + $('#company-name').val();
            //values += '&cui_attribute=' + $('#company-cui-attribute').val();
            values += '&cui_number=' + $('#company-cui-number').val();
            //values += '&nr_reg_com_1=' + $('#company-nrregcom-1').val();
            //values += '&nr_reg_com_2=' + $('#company-nrregcom-2').val();
            //values += '&nr_reg_com_3=' + $('#company-nrregcom-3').val();
            //values += '&nr_reg_com_4=' + $('#company-nrregcom-4').val();
            //values += '&bank=' + $('#company-bank').val();
            //values += '&bank_account=' + $('#company-bank-account').val();
            //values += '&county=' + $('#company-county option:selected').val();
            //values += '&city=' + $('#company-city option:selected').val();
			values += '&country=' + $('#company-country option:selected').val();
			values += '&county=' + $('#company-county').val();
            values += '&city=' + $('#company-city').val();
            values += '&address=' + $('#company-address').val();
            values += '&zip_code=' + $('#company-zip-code').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-company`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).parent().addClass('has-error');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						var rowHtml = `<div class="col-md-9">
							<div class="company-contact">${response.data.name}</div>
							<div class="company-text">${response.data.cui}</div>
							<div class="company-text">${response.data.address}${(response.data.city!=''?', ' + response.data.city:'')}${(response.data.country!=''?', ' + response.data.country:'')}</div>
						</div>
						<div class="col-md-3 buttons">
							<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small edit-company">Modifica</a>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small delete-company">Sterge</a>
						</div>`;
						$('#company-' + id).html(rowHtml);

                        $('#company-modal').modal('hide');
						$('#company-modal').html('');

						return;
                    }
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },
        deleteCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			Swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {

				if (_this.isLoading) {
	                return false;
	            }

				//Loading...
	            _this.isLoading = true;

	            var values = '_token=' + $('#_token_company_list').val();
				values += '&id=' + id;
	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/delete-company`,
	                data: values,
	                beforeSend: function() {
	                    _this.isLoading = true;
	                },
	                complete: function() {
	                    _this.isLoading = false;
	                },
	                success: function(response, xhr) {
	                    _this.isLoading = false;

	                    if (response.status == 1) {
							$('#company-' + id).remove();
							Swal.fire(
								'Deleted!',
								'Your company has been deleted.',
								'success'
		    				);

							if ($('#companies-container').children().length == 0){
								$('#companies-container').html('<div class="empty-results">Nu ai nicio companie salvata!</div>');
							} else {
								console.log('is not epmtpy');
							}

							return;
	                    }
	                },
	                error(error) {
	                    _this.isLoading = false;
	                },
	            });

  				//if (result.value) {}
			});
		},
        addNewCompanyModal(event) {
			const _this = event.data;

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/company`,
				success: function(response, xhr) {
                    $('#company-modal').html(response);
                    $('#company-modal').modal('show');
                },
                error(error) {
                    console.log(error);
                },
			});
		},
        saveCompany(event) {
            const _this = event.data;
			const source = $(this).data('source');

			if (_this.isLoading) {
                return false;
            }

            $('.form-new-company').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#company-name').val() == '') {
				$('#company-name').addClass('is-invalid');
				errors = true;
			}
			if ($('#company-cui-number').val() == '') {
				$('#company-cui-number').addClass('is-invalid');
				errors = true;
			}
			/*if ($('#company-county option:selected').val() == '') {
				$('#company-county').parent().addClass('has-error');
				errors = true;
			}
			if ($('#company-city option:selected').val() == '') {
				$('#company-city').parent().addClass('has-error');
				errors = true;
			}*/
			if ($('#company-city').val() == '') {
				$('#company-city').addClass('is-invalid');
				errors = true;
			}
			if ($('#company-address').val() == '') {
				$('#company-address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $('#_token_company').val();
            values += '&name=' + $('#company-name').val();
            //values += '&cui_attribute=' + $('#company-cui-attribute').val();
            values += '&cui_number=' + $('#company-cui-number').val();
            //values += '&nr_reg_com_1=' + $('#company-nrregcom-1').val();
            //values += '&nr_reg_com_2=' + $('#company-nrregcom-2').val();
            //values += '&nr_reg_com_3=' + $('#company-nrregcom-3').val();
            //values += '&nr_reg_com_4=' + $('#company-nrregcom-4').val();
            //values += '&bank=' + $('#company-bank').val();
            //values += '&bank_account=' + $('#company-bank-account').val();
            //values += '&county=' + $('#company-county option:selected').val();
            //values += '&city=' + $('#company-city option:selected').val();
			values += '&country=' + $('#company-country option:selected').val();
			values += '&county=' + $('#company-county').val();
            values += '&city=' + $('#company-city').val();
            values += '&address=' + $('#company-address').val();
            values += '&zip_code=' + $('#company-zip-code').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/company`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).parent().addClass('has-error');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						if(source == 'reservation-page') {
							$('#billing-companies-wrapper .empty').remove();

							var rowHtml = `<div class="row wrap-row billing-company mb-3" data-id="${response.data.id}" id="billing-company-${response.data.id}">
								<div class="col-sm-12 col-md-12">
									<div class="p-3 border border-secondary">
										<div class="form-check ps-3">
											<input class="form-check-input" name="billing_company" id="billing_company_${response.data.id}" type="radio" value="${response.data.id}">
											<label class="form-check-label" for="billing_company_${response.data.id}">
												<div class="company-contact">${response.data.name}</div>
												<div class="company-text">${response.data.cui}</div>
												<div class="company-text">${response.data.address}${(response.data.city!=''?', ' + response.data.city:'')}${(response.data.country!=''?', ' + response.data.country:'')}</div>
											</label>
										</div>
									</div>
								</div>
							</div>`;
							$('#billing-companies-wrapper').prepend(rowHtml);

	                        $('#billing-company-modal').modal('hide');
							$('#billing-company-modal').html('');
						} else {
							$('.empty-results').remove();

							var rowHtml = `<div class="row wrap-row" id="company-${response.data.id}">
								<div class="col-md-9">
									<div class="company-contact">${response.data.name}</div>
									<div class="company-text">${response.data.cui}</div>
									<div class="company-text">${response.data.address}${(response.data.city!=''?', ' + response.data.city:'')}${(response.data.country!=''?', ' + response.data.country:'')}</div>
								</div>
								<div class="col-md-3 buttons">
									<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small edit-company">Modifica</a>
									<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small delete-company">Sterge</a>
								</div>
							</div>`;
							$('#companies-container').prepend(rowHtml);

	                        $('#company-modal').modal('hide');
							$('#company-modal').html('');
						}

						return;
                    }
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },

    };

    if ($('.account-companies-section').length || $('#add-new-billing-company').length) {
        companies.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/companies.js